var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M72 8L88 24M30 82L76 36L60 20L14 66L8 88L30 82Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Pencil.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Pencil;

Pencil.default = Pencil;
